<!--The content below is only a placeholder and can be replaced.-->
<!-- [plotOptions]="chartOptions.plotOptions" -->

<div id="chart">
  <apx-chart [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [dataLabels]="chartOptions.dataLabels"
    [plotOptions]="chartOptions.plotOptions"
    [yaxis]="chartOptions.yaxis"
    [xaxis]="chartOptions.xaxis"
    [legend]="chartOptions.legend"
    [colors]="chartOptions.colors"
    [grid]="chartOptions.grid"></apx-chart>
</div>